import React from "react";
import styled from "@emotion/styled";
import MenuIcon from '@mui/icons-material/Menu';
import PersonIcon from '@mui/icons-material/Person';
import AddIcon from '@mui/icons-material/Add';
import IconButton from '@mui/material/IconButton';
import UserModal from "./userinfo";
import { ArrowBack } from "@mui/icons-material";
const Main = styled.div`
   display:flex;
   flex-direction:row;
   justify-content:space-between;
   align-items:center;
   direction:rtl;
   padding:3px 20px;
`
const P = styled.p`
    font-family:SansX;
    color:#5C5C5C;
    font-weight:600;
`
export default function Navbar(props) {
    const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
    const { Button, Detatil } = props;
    return (
        <Main>
            {window.location.pathname !== '/driverDashboard' ?
            <IconButton href={Button}>
                <ArrowBack  />
            </IconButton>
             :null}
            {/* <MenuIcon /> */}
            <P>{Detatil}</P>
            <UserModal open={open} handleOpen={handleOpen} handleClose={handleClose} />
        </Main>
    )
}